(function () {
  "use strict";

  var targetLabel = "add on services: base cut,haircut,gray hair,perm";
  var scanTimer = null;
  var scanScopes = [];
  var refreshTimers = new WeakMap();
  var serviceGroupIndex = 0;
  var language = String(document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var translations = {
    en: {
      heading: "Customize before shipping",
      optional: "Optional",
      choose: "Choose customization",
      hide: "Hide customization",
      selected: "{count} selected",
      selectedServices: "{count} service(s) selected",
      finalSale: "Final pricing updates above. Customized units are final sale after service work begins.",
      haircutTitle: "Professional haircut",
      haircutDescription: "Choose a finished hairstyle before shipping.",
      baseCutTitle: "Base cut to your measurements",
      baseCutDescription: "Trim the stock base to the confirmed size you provide.",
      grayTitle: "Gray hair adjustment",
      grayDescription: "Increase the gray percentage only when the stock shade needs it.",
      grayPrice: "From +$25",
      permTitle: "Wave or curl perm",
      permDescription: "Add permanent wave or curl processing before shipping."
    },
    fr: {
      heading: "Personnaliser avant l’expédition",
      optional: "Facultatif",
      choose: "Choisir les personnalisations",
      hide: "Masquer les personnalisations",
      selected: "{count} sélectionné(s)",
      selectedServices: "{count} service(s) sélectionné(s)",
      finalSale: "Le prix final est mis à jour ci-dessus. Les unités personnalisées ne peuvent plus être retournées après le début du service.",
      haircutTitle: "Coupe professionnelle",
      haircutDescription: "Choisissez une coiffure finie avant l’expédition.",
      baseCutTitle: "Découpe de la base selon vos mesures",
      baseCutDescription: "La base en stock est découpée aux dimensions confirmées.",
      grayTitle: "Ajustement des cheveux gris",
      grayDescription: "Augmentez le pourcentage de gris uniquement si la teinte en stock doit être adaptée.",
      grayPrice: "À partir de +25 $",
      permTitle: "Permanente ondulée ou bouclée",
      permDescription: "Ajoutez une ondulation ou des boucles permanentes avant l’expédition."
    },
    de: {
      heading: "Vor dem Versand anpassen",
      optional: "Optional",
      choose: "Anpassungen auswählen",
      hide: "Anpassungen ausblenden",
      selected: "{count} ausgewählt",
      selectedServices: "{count} Service(s) ausgewählt",
      finalSale: "Der Endpreis wird oben aktualisiert. Bearbeitete Einheiten sind nach Beginn der Dienstleistung vom Umtausch ausgeschlossen.",
      haircutTitle: "Professioneller Haarschnitt",
      haircutDescription: "Wählen Sie vor dem Versand eine fertige Frisur.",
      baseCutTitle: "Basiszuschnitt nach Ihren Maßen",
      baseCutDescription: "Die Lagerbasis wird auf die bestätigten Maße zugeschnitten.",
      grayTitle: "Grauhaar-Anpassung",
      grayDescription: "Erhöhen Sie den Grauanteil nur, wenn die Lagerfarbe angepasst werden muss.",
      grayPrice: "Ab +25 $",
      permTitle: "Wellen- oder Lockenpermanent",
      permDescription: "Fügen Sie vor dem Versand dauerhafte Wellen oder Locken hinzu."
    },
    es: {
      heading: "Personalizar antes del envío",
      optional: "Opcional",
      choose: "Elegir personalizaciones",
      hide: "Ocultar personalizaciones",
      selected: "{count} seleccionado(s)",
      selectedServices: "{count} servicio(s) seleccionado(s)",
      finalSale: "El precio final se actualiza arriba. Las unidades personalizadas son venta final una vez iniciado el servicio.",
      haircutTitle: "Corte profesional",
      haircutDescription: "Elige un peinado terminado antes del envío.",
      baseCutTitle: "Recorte de base según tus medidas",
      baseCutDescription: "Recortamos la base en stock a las medidas confirmadas.",
      grayTitle: "Ajuste de canas",
      grayDescription: "Aumenta el porcentaje de canas solo cuando sea necesario ajustar el tono en stock.",
      grayPrice: "Desde +25 $",
      permTitle: "Permanente ondulada o rizada",
      permDescription: "Añade ondas o rizos permanentes antes del envío."
    }
  };
  var copy = translations[language] || translations.en;

  var services = [
    {
      key: "haircut",
      selector: 'input[name="Haircut Services"]',
      title: copy.haircutTitle,
      description: copy.haircutDescription,
      price: "+$35"
    },
    {
      key: "base-cut",
      selector: 'select[name="Base Cut Service"]',
      title: copy.baseCutTitle,
      description: copy.baseCutDescription,
      price: "+$10"
    },
    {
      key: "gray",
      selector: 'select[name="Gray hair percentage"]',
      title: copy.grayTitle,
      description: copy.grayDescription,
      price: copy.grayPrice
    },
    {
      key: "perm",
      selector: 'select[name="Perm"]',
      title: copy.permTitle,
      description: copy.permDescription,
      price: "+$35"
    }
  ];

  function normalize(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function optionForControl(control, child) {
    if (!control) return null;
    return control.closest(".avp-option") || child;
  }

  function addServiceMeta(option, service) {
    option.classList.add("rehair-stock-service", "rehair-stock-service--" + service.key);
    option.setAttribute("data-rehair-service", service.key);

    var title = option.querySelector(".avp-option-title .apo-title");
    if (title) {
      title.textContent = service.title;
    }

    if (!option.querySelector("[data-rehair-service-meta]")) {
      var meta = document.createElement("div");
      meta.className = "rehair-stock-service__meta";
      meta.setAttribute("data-rehair-service-meta", "");
      meta.innerHTML =
        '<p>' + service.description + '</p>' +
        '<span>' + service.price + '</span>';
      var labelRow = option.querySelector(".ap-label-tooltip, .avp-option-title");
      if (labelRow && labelRow.parentNode) labelRow.parentNode.insertBefore(meta, labelRow.nextSibling);
      else option.insertBefore(meta, option.firstChild);
    }
  }

  function selectedFor(service, root) {
    if (service.key === "haircut") {
      var checked = root.querySelector('input[name="Haircut Services"]:checked');
      return !!checked && !/no haircut/i.test(checked.value || "");
    }

    var control = root.querySelector(service.selector);
    if (!control) return false;
    var value = String(control.value || "");
    if (service.key === "base-cut") return !/no base cut/i.test(value);
    if (service.key === "gray") return !/don't want|do not want|no change/i.test(value);
    if (service.key === "perm") return !/no perm/i.test(value);
    return false;
  }

  function markSmallestNote(root, text, className) {
    Array.prototype.forEach.call(root.querySelectorAll("p, small, span, div"), function (element) {
      if (element.children.length > 0) return;
      if (normalize(element.textContent).indexOf(normalize(text)) === -1) return;
      element.classList.add("rehair-stock-services__app-note", className);
    });
  }

  function updateState(root) {
    var selected = [];

    services.forEach(function (service) {
      var option = root.querySelector('[data-rehair-service="' + service.key + '"]');
      var active = selectedFor(service, root);
      if (option) option.setAttribute("data-selected", active ? "true" : "false");
      if (active) selected.push(service);
    });

    root.classList.toggle("rehair-stock-services--has-selection", selected.length > 0);
    root.classList.toggle(
      "rehair-stock-services--has-gray",
      selected.some(function (service) { return service.key === "gray"; })
    );

    var toggleCount = root.querySelector("[data-rehair-service-toggle-count]");
    if (toggleCount) toggleCount.textContent = copy.selected.replace("{count}", selected.length);

    var summary = root.querySelector("[data-rehair-service-summary]");
    if (!summary) return;

    var selectedCount = String(selected.length);
    if (summary.getAttribute("data-selected-count") === selectedCount) return;
    summary.setAttribute("data-selected-count", selectedCount);

    if (!selected.length) {
      summary.innerHTML = "";
      summary.hidden = true;
      summary.setAttribute("data-has-selection", "false");
      return;
    }

    summary.hidden = false;
    summary.innerHTML =
      '<strong>' + copy.selectedServices.replace("{count}", selected.length) + '</strong>' +
      '<span>' + copy.finalSale + '</span>';
    summary.setAttribute("data-has-selection", "true");
  }

  function refreshState(root) {
    if (!root || !root.isConnected) return;

    var existingTimer = refreshTimers.get(root);
    if (existingTimer) window.clearTimeout(existingTimer);

    updateState(root);
    refreshTimers.set(root, window.setTimeout(function () {
      if (root.isConnected) updateState(root);
      refreshTimers.delete(root);
    }, 180));
  }

  function decorate(root) {
    if (!root) return;

    if (
      root.getAttribute("data-rehair-stock-services") === "true" &&
      root.querySelector("[data-rehair-services-toggle]")
    ) {
      updateState(root);
      return;
    }

    root.setAttribute("data-rehair-stock-services", "true");
    root.classList.add("rehair-stock-services");

    var groupHeader = root.querySelector(".apo-option-group");
    var groupTitle = groupHeader && groupHeader.querySelector(".apo-title");
    if (groupTitle) groupTitle.textContent = copy.heading;

    if (groupHeader && !root.querySelector("[data-rehair-services-optional]")) {
      var optional = document.createElement("span");
      optional.className = "rehair-stock-services__optional";
      optional.setAttribute("data-rehair-services-optional", "");
      optional.textContent = copy.optional;
      groupHeader.appendChild(optional);
    }

    var child = root.querySelector(".apo-group-child");
    if (!child) return;
    var optionsContainer = child.parentNode;
    if (!optionsContainer || !optionsContainer.parentNode) return;

    child.classList.add("rehair-stock-services__options");
    if (!child.id) {
      serviceGroupIndex += 1;
      child.id = "rehair-stock-services-options-" + serviceGroupIndex;
    }

    if (!root.querySelector("[data-rehair-services-toggle]")) {
      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "rehair-stock-services__toggle";
      toggle.setAttribute("data-rehair-services-toggle", "");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-controls", child.id);
      toggle.innerHTML =
        '<strong data-rehair-service-toggle-label>' + copy.choose + '</strong>' +
        '<small data-rehair-service-toggle-count>' + copy.selected.replace("{count}", 0) + '</small>';
      optionsContainer.parentNode.insertBefore(toggle, optionsContainer);
      root.setAttribute("data-rehair-services-expanded", "false");

      toggle.addEventListener("click", function () {
        var expanded = root.getAttribute("data-rehair-services-expanded") === "true";
        expanded = !expanded;
        root.setAttribute("data-rehair-services-expanded", expanded ? "true" : "false");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        var label = toggle.querySelector("[data-rehair-service-toggle-label]");
        if (label) label.textContent = expanded ? copy.hide : copy.choose;
      });
    }

    services.forEach(function (service) {
      var control = root.querySelector(service.selector);
      var option = optionForControl(control, child);
      if (option) addServiceMeta(option, service);
    });

    Array.prototype.forEach.call(child.children, function (option) {
      if (!option.matches || !option.matches(".avp-option")) return;
      var text = normalize(option.textContent);
      if (text.indexOf("hair style images") !== -1 || text.indexOf("haircut specification") !== -1) {
        option.classList.add("rehair-stock-service__followup");
        option.setAttribute("data-related-service", "haircut");
      }
      if (text.indexOf("custom base size") !== -1) {
        option.classList.add("rehair-stock-service__followup");
        option.setAttribute("data-related-service", "base-cut");
      }
    });

    markSmallestNote(root, "Afro hair products are not eligible", "rehair-stock-services__gray-note");
    markSmallestNote(root, "Customized products are FINAL SALE", "rehair-stock-services__final-sale");

    if (!root.querySelector("[data-rehair-service-summary]")) {
      var summary = document.createElement("div");
      summary.className = "rehair-stock-services__summary";
      summary.setAttribute("data-rehair-service-summary", "");
      optionsContainer.parentNode.insertBefore(summary, optionsContainer.nextSibling);
    }

    refreshState(root);
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var labels = [];

    if (context.matches && context.matches(".app-avis-product-options-block .apo-title")) {
      labels.push(context);
    }

    Array.prototype.forEach.call(
      context.querySelectorAll(".app-avis-product-options-block .apo-title"),
      function (label) {
        if (labels.indexOf(label) === -1) labels.push(label);
      }
    );

    if (
      context !== document &&
      context.closest &&
      context.closest(".app-avis-product-options-block")
    ) {
      Array.prototype.forEach.call(context.querySelectorAll(".apo-title"), function (label) {
        if (labels.indexOf(label) === -1) labels.push(label);
      });
    }

    labels.forEach(function (label) {
      var title = normalize(label.textContent);
      if (title !== targetLabel && title !== "optional finishing services" && title !== "pre-shipping hair services") return;
      var root = label.closest(".apo-group-accordion") || label.closest(".avp-option");
      decorate(root);
    });
  }

  function scheduleScan(scope) {
    if (scope && scanScopes.indexOf(scope) === -1) scanScopes.push(scope);
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      var scopes = scanScopes.slice();
      scanScopes.length = 0;
      scopes.forEach(scan);
    }, 80);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  document.addEventListener("change", function (event) {
    var target = event.target;
    var root = target && target.closest ? target.closest("[data-rehair-stock-services]") : null;
    if (root) refreshState(root);
  }, true);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (!node || node.nodeType !== 1) return;
        if (
          (node.matches && node.matches(".app-avis-product-options-block, .apo-title")) ||
          (node.querySelector && node.querySelector(".app-avis-product-options-block, .apo-title"))
        ) {
          scheduleScan(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(scan, 900);
  window.setTimeout(scan, 2200);
  window.setTimeout(scan, 4500);
})();
